module.exports = __webpack_public_path__ + "img/layanan.bb6dbd22.png";